/* Let CRA handle linting for sample app */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { Prompt } from 'react-router-dom';

// VENDOR UTILS
import { createSession, OTSession, OTSubscriber, OTStreams, OTPublisher } from 'opentok-react';
import AccCore from 'opentok-accelerator-core';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

//Components
import InteractionPanel from 'components/InteractionComponents/InteractionPanel';
import FlexColumn from 'components/Primatives/FlexColumn';
// STYLES
import {
    OuterContainer,
    VideoContainer,
    Subscriber,
    Publisher,
    Controls,
    ControlsContainer,
    VideoSection,
    HideInteraction,
} from './styles';
import { JoinCallMask } from './JoinCallMask';
import { constants } from '../../constants/index';

import ConfirmEndCall from 'components/Dialog/ConfirmEndCall';

class VideoUI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewIndex: 1,
            shouldStreamAudio: true,
            connected: false,
            error: null,
            shouldJoin: false,
            shouldStreamVideo: true,
            videoOn: true,
            shouldShowInteractionPanel: false,
            didInitSessionInteractionVisibility: false,
            showPromptOnNav: true,
        };

        this.subscriberProperties = {
            preferredFrameRate: 15,
            shouldShowControls: false,
        };

        this.subscriberEventHandlers = {
            videoDisabled: event => {
                this.setState({
                    videoOn: false,
                });
            },
            videoEnabled: event => {
                this.setState({
                    videoOn: true,
                });
                // console.log('Subscriber video enabled!');
            },
        };

        this.publisherProperties = {
            audioFallbackEnabled: false,
            publishAudio: this.state.shouldStreamAudio,
            publishVideo: this.state.shouldStreamVideo,
            shouldShowControls: false,
            facingMode: 'user',
        };

        this.subscriberProperties = {
            height: '100%',
            width: '100%',
        };

        this.publisherEventHandlers = {
            streamCreated: event => {
                // console.log('Publisher stream created!');
                this.setState({});
            },
            streamDestroyed: event => {
                // console.log(this.state.session);
                // console.log('Publisher stream destroyed!');
            },
        };
    }

    componentDidMount() {
        const { userData } = this.props;
        // REMOVE BELLOW IF STATEMENT WHEN ADDING CONSUMER SERVICE RATINGS
        if (userData && !userData.provider) {
            this.handleNoPromptOnNav();
            this.props.closeConfirmEndCallDialog();
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (!this.state.didInitSessionInteractionVisibility) {
            if (this.props.screenWidth > constants.layout.breakpoint.break1) {
                this.setState({
                    shouldShowInteractionPanel: true,
                    didInitSessionInteractionVisibility: true,
                });
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.shouldJoin && !this.state.session) {
            let session;
            const { sessionData } = nextProps;
            const { id, token, apiKey } = sessionData;
            // console.log(sessionData, '#########');
            if (!!sessionData) {
                session = OT.initSession(apiKey, id);
                // console.log(OT, session, '$&$&$&$&$');
                session.connect(
                    token,
                    function(error) {
                        if (error) {
                            // console.log("Error connecting: ", error.name, error.message);
                        } else {
                            // console.log("Connected to the session.");
                        }
                    },
                );
            }
            this.setState({
                session: session,
                streams: session.streams,
            });
        }
    }

    componentWillUnmount() {
        if (this.state.session) {
            this.state.session.disconnect();
        }
    }

    videoToggle = () => {
        this.setState(prevState => ({
            shouldStreamVideo: !prevState.shouldStreamVideo,
        }));
    };

    audioToggle = () => {
        this.setState(prevState => ({
            shouldStreamAudio: !prevState.shouldStreamAudio,
        }));
    };

    endSession = () => {
        this.setState(
            {
                session: null,
                shouldJoin: false,
            },
            () => {
                // REMOVE BELLOW IF STATEMENT WHEN ADDING CONSUMER SERVICE RATINGS
                if (this.props.userData && !this.props.userData.provider) {
                    this.props.handleSkipConfirmEndCallDialog();
                } else {
                    this.props.openConfirmEndCallDialog();
                }
            },
        );
        this.state.session.disconnect();
    };

    joinSession = () => {
        this.setState(
            {
                shouldJoin: true,
            },
            () => {
                if (this.state.shouldJoin && !this.state.session) {
                    let session;
                    const { sessionData } = this.props;
                    const { id, token, apiKey } = sessionData;
                    if (!!sessionData) {
                        session = OT.initSession(apiKey, id);
                        session.connect(
                            token,
                            function(error) {
                                if (error) {
                                    // console.log("Error connecting: ", error.name, error.message);
                                } else {
                                    // console.log("Connected to the session.");
                                }
                            },
                        );
                    }
                    this.setState({
                        session: session,
                        streams: session.streams,
                    });
                }
            },
        );
    };

    onSessionError = err => {
        // console.log('There was an error in creating a session!');
        this.setState({
            error: `Failed to connect: ${err.message}`,
        });
    };

    toggleInteraction = () => {
        const { shouldShowInteractionPanel } = this.state;
        if (shouldShowInteractionPanel) {
            this.setState(
                {
                    shouldShowInteractionPanel: false,
                },
                () => {
                    if (this.props.screenWidth < constants.layout.breakpoint.break1) {
                        this.setState({
                            shouldStreamVideo: true,
                        });
                    }
                },
            );
        } else if (!shouldShowInteractionPanel) {
            this.setState(
                {
                    shouldShowInteractionPanel: true,
                },
                () => {
                    if (this.props.screenWidth < constants.layout.breakpoint.break1) {
                        this.setState({
                            shouldStreamVideo: false,
                        });
                    }
                },
            );
        }
    };

    handleChangeViewIndex = index => {
        // console.log('Changing index to ', index);
        this.setState(
            {
                viewIndex: index,
            },
            () => {
                console.log(this.state.viewIndex);
            },
        );
    };

    handleNoPromptOnNav = () => {
        this.setState(
            {
                showPromptOnNav: false,
            },
            () => {
                console.log('Call Ended');
            },
        );
    };

    render() {
        const { sessionData } = this.props;
        const { service, company, provider } = this.props;
        const serviceId = this.props.consultService && this.props.consultService._id;
        const breakPoint = constants.layout.breakpoint.break1;
        let maxWidth = 380;
        if (this.props.screenWidth < breakPoint) {
            maxWidth = this.props.screenWidth - 50;
        }
        // console.log('VidioUI-sessionData@', sessionData)
        // console.log('VidioUI-this.state', this.state)
        // console.log('this.state.service', this.state.service)
        // console.log('this.props', this.props)
        // console.log('VidioUI-this.id', this.props.consultService && this.props.consultService._id)
        // console.log('VidoeUi-companyServiceProvider', service, company, provider)
        // console.log('serviceId', serviceId)
        // console.log('@@service', this.props.consultService)
        // console.log('VidoeUi-screenWidth', this.props.screenWidth)
        // console.log('VidoeUi-shouldShowInteractionPanel', this.state.shouldShowInteractionPanel)
        // console.log('VidoeUi-facingMode', this.state.facingMode)
        return (
            <OuterContainer id="OuterContainer">
                <Prompt
                    when={this.state.showPromptOnNav}
                    message={(location, action) => {
                        console.log('Prompt-location', location);
                        // console.log('Prompt-action', action)
                        this.props.openConfirmEndCallDialog(location);
                        return false;
                    }}
                />
                {sessionData && this.state.shouldJoin && this.state.session && (
                    <React.Fragment>
                        <React.Fragment>
                            {service &&
                                company &&
                                provider &&
                                this.state.shouldShowInteractionPanel && (
                                    <InteractionPanel
                                        provider={provider}
                                        service={service}
                                        company={company}
                                        clientIndex={this.props.clientIndex}
                                        selectedService={service}
                                        handleChangeViewIndex={this.handleChangeViewIndex}
                                        viewIndex={this.state.viewIndex}
                                        shouldHideBookingTab
                                        style={{ maxWidth: maxWidth }}
                                        isDuringVideoSession
                                    />
                                )}
                            <div
                                style={{
                                    position: 'relative',
                                    top: 0,
                                    left: 0,
                                    zIndex: 1,
                                    width: '0px',
                                }}
                            >
                                <HideInteraction
                                    className="HideInteraction"
                                    onClick={this.toggleInteraction}
                                >
                                    {this.state.shouldShowInteractionPanel ? (
                                        <FontAwesomeIcon icon={['fas', 'chevron-circle-left']} />
                                    ) : (
                                        <FontAwesomeIcon icon={['fas', 'keyboard']} />
                                    )}
                                </HideInteraction>
                            </div>
                        </React.Fragment>
                        {!this.props.shouldRefreshSession && (
                            <VideoSection
                                hideVideoSection={
                                    this.state.shouldShowInteractionPanel &&
                                    !(this.props.screenWidth > breakPoint)
                                }
                                className="VideoSection"
                            >
                                {this.state.session && (
                                    <VideoContainer className="VideoContainer">
                                        <FlexColumn style={{ flex: 1 }}>
                                            <Subscriber className="Subscriber">
                                                <OTSession
                                                    apiKey={sessionData.apiKey}
                                                    sessionId={sessionData.id}
                                                    token={sessionData.token}
                                                    // eventHandlers={this.sessionEvents}
                                                    onSessionError={this.onSessionError}
                                                >
                                                    <OTStreams>
                                                        <OTSubscriber
                                                            properties={this.subscriberProperties}
                                                        />
                                                    </OTStreams>
                                                </OTSession>
                                            </Subscriber>
                                        </FlexColumn>
                                        <Publisher className="Publisher">
                                            <OTPublisher
                                                session={this.state.session}
                                                properties={{
                                                    publishAudio: this.state.shouldStreamAudio,
                                                    publishVideo: this.state.shouldStreamVideo,
                                                    facingMode: this.props.facingMode,
                                                    shouldShowControls: false,
                                                    style: {
                                                        buttonDisplayMode: 'off', //not working, not sure why
                                                        audioLevelDisplayMode: 'off',
                                                    },
                                                }}
                                                eventHandlers={this.publisherEventHandlers}
                                                // properties={this.state.publisherProperties}//facingMode='user'//'environment'
                                            />
                                        </Publisher>
                                    </VideoContainer>
                                )}
                                <ControlsContainer className="ControlsContainer">
                                    <Controls className="ControlsContainer">
                                        <div>
                                            {this.state.session && !!this.state.shouldStreamAudio && (
                                                <button
                                                    className="icon white"
                                                    onClick={this.audioToggle}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'microphone']}
                                                        // style={ {...styles.buttonIconStyle, fontSize: props.iconSize} }
                                                    />
                                                </button>
                                            )}
                                            {this.state.session && !this.state.shouldStreamAudio && (
                                                <button
                                                    className="icon black"
                                                    onClick={this.audioToggle}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'microphone-slash']}
                                                    />
                                                </button>
                                            )}
                                            {/*true && <button className="icon" onClick={this.endSession}><i className="fa fa-phone" data-fa-transform="rotate--155"></i></button>*/}
                                            {this.state.session && (
                                                <button className="icon" onClick={this.endSession}>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'phone-slash']}
                                                    />
                                                </button>
                                            )}
                                            {this.state.session && !this.state.shouldStreamVideo && (
                                                <button
                                                    className="icon black"
                                                    onClick={this.videoToggle}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'video-slash']}
                                                    />
                                                </button>
                                            )}
                                            {this.state.session && !!this.state.shouldStreamVideo && (
                                                <button
                                                    className="icon white"
                                                    onClick={this.videoToggle}
                                                >
                                                    <FontAwesomeIcon icon={['fas', 'video']} />
                                                </button>
                                            )}
                                            {this.state.session && !!this.state.shouldStreamVideo && (
                                                <button
                                                    className="icon white"
                                                    onClick={this.props.cameraToggle}
                                                >
                                                    <FontAwesomeIcon icon={['far', 'repeat-alt']} />
                                                </button>
                                            )}
                                            {this.state.error && <p>{this.state.error}</p>}
                                        </div>
                                    </Controls>
                                </ControlsContainer>
                            </VideoSection>
                        )}
                    </React.Fragment>
                )}
                {!this.state.session && !this.state.shouldJoin && (
                    <JoinCallMask>
                        <p />
                        {!this.props.userId && (
                            <button
                                className="text"
                                onClick={() => {
                                    this.props.showLoginStart(this.joinSession);
                                }}
                            >
                                Start Consultation
                            </button>
                        )}

                        {this.props.userId && (
                            <button
                                className="text"
                                onClick={() => {
                                    this.joinSession();
                                }}
                            >
                                Start Consultation
                            </button>
                        )}
                        {/* <p>By clicking the "Start Consultation" button, you agree to the Cyno <a href="">terms and conditions</a> and <a href="">privacy policy</a></p> */}
                        {/* <div className="maskImage"></div> */}
                        {/* <div className="maskTint"></div> */}
                    </JoinCallMask>
                )}
                <ConfirmEndCall
                    modal={false}
                    open={this.props.isConfirmEndCallDialogOpen}
                    handleClose={this.props.closeConfirmEndCallDialog}
                    user={this.props.userData}
                    rejoinCall={this.joinSession}
                    otherVideoUser={this.props.otherVideoUser}
                    consultService={this.props.consultService}
                    handleNoPromptOnNav={this.handleNoPromptOnNav}
                />
            </OuterContainer>
        );
    }
}

const styles = {
    buttonIconStyles: {
        color: 'white',
        width: 50,
        height: 50,
    },
};

import { openConfirmEndCallDialog, closeConfirmEndCallDialog } from 'actions';
export default connect(
    null,
    { closeConfirmEndCallDialog, openConfirmEndCallDialog },
)(VideoUI);



// WEBPACK FOOTER //
// ./src/js/components/VideoUI/VideoUI.jsx